export var AVAILABLE_FIELD = 'available';
export var PRICE_FIELD = 'price';